<div class="cx-page" *ngIf="model$ | async as model; else loading" [ngClass]="listViewSelected ? 'padding-large' : 'padding-small'">
  <section
    class="cx-page-section"
    *ngIf="model1$ | async as pageModel; else loading"
  >
    <div class="container">

      <div class="row">
        <div class="col-12 col-lg-12" *ngIf="viewMode$ | async as viewMode">
          <div class="cx-sorting top custom-margin-top">
            <div class="row">
              <div class="col-3 p-0">
                <span class="item-found" *ngIf="pageModel?.pagination?.totalResults !== 1"
                  >{{ pageModel?.pagination?.totalResults }}
                  {{ "plp.itemFound" | cxTranslate }}</span>
                <span class="item-found" *ngIf="pageModel?.pagination?.totalResults === 1"
                  >{{ pageModel?.pagination?.totalResults }}
                  {{ "plp.oneitemFound" | cxTranslate }}</span>
              </div>
              <div
                *ngIf="pageModel.pagination?.totalResults < itemsPerPage"
                class="col-3"
              ></div>
              <div
                *ngIf="pageModel.pagination?.totalResults < itemsPerPage"
                class="col-2"
              ></div>
              <div class="col-3">
                <h4 class="sort_text">{{ "plp.sortByHdr" | cxTranslate }}</h4>
                <div class="form-group cx-sort-dropdown">
                  <cx-sorting
                    [sortOptions]="
                      pageModel.sorts
                    "
                    (sortListEvent)="sortList($event)"
                    [selectedOption]="
                     pageModel.pagination.sort
                    "
                    placeholder="{{
                      'productList.sortByRelevance' | cxTranslate
                    }}"
                  ></cx-sorting>
                </div>
              </div>

              <div class="col-3 hidden"></div>

              <div *ngIf="!isInfiniteScroll && pageModel.pagination?.totalResults > itemsPerPage" class="col-auto">
                <h4 class="sort_text">
                  {{ "plp.itemPerPageHdr" | cxTranslate }}
                </h4>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "plp.selectPlaceholder" | cxTranslate }}'
                  class="items-per-page"
                  [(ngModel)]="itemsPerPage"
                  (change)="getValue($event)"
                >
                  <ng-option [value]="50" ng-selected="itemsPerPage == 50 ? true: false">50</ng-option>
                  <ng-option [value]="100" *ngIf="pageModel.pagination?.totalResults > 50" ng-selected="itemsPerPage == 100 ? true: false">100</ng-option>
                  <ng-option [value]="200" *ngIf="pageModel.pagination?.totalResults > 100" ng-selected="itemsPerPage == 200 ? true: false">200</ng-option>
                  <ng-option [value]="500" *ngIf="pageModel.pagination?.totalResults > 200" ng-selected="itemsPerPage == 500 ? true: false">500</ng-option>
                </ng-select>
              </div>
              <div
                *ngIf="
                  !isInfiniteScroll &&
                  pageModel.pagination?.totalResults > itemsPerPage
                "
                class="col-3"
              >
                <div
                  class="cx-pagination"
                  aria-label="product search pagination"
                >
                  <cx-pagination
                    [pagination]="pageModel.pagination"
                    queryParam="currentPage"
                    [defaultPage]="currentPage"
                    (viewPageEvent)="currentPage($event)"
                  ></cx-pagination>
                </div>
              </div>

              <div class="col-1 ml-auto ml-lg-0 mt-22">
                <vs-product-view
                  (modeChange)="setViewMode($event)"
                  [mode]="viewMode"
                ></vs-product-view>
              </div>
            </div>
          </div>
          <div class="cx-product-container">
            <!-- Product list when using pagination -->
            <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">
              <ng-container *ngIf="viewMode === ViewModes.Grid">
                <div class="row">
                  <vs-product-grid-item
                    *ngFor="
                      let product of pageModel.products
                    "
                    [product]="product"
                    class="col-12 col-sm-6 col-md-3"
                  ></vs-product-grid-item>
                </div>
                <div *ngIf="pageModel?.products.length < 1">
                  <h2>
                    <vs-product-not-found></vs-product-not-found>
                  </h2>
                </div>
              </ng-container>
              <ng-container *ngIf="viewMode === ViewModes.List">
                <vs-product-list-item
                  *ngFor="
                    let product of pageModel.products
                  "
                  [product]="product"
                  class="cx-product-search-list"
                ></vs-product-list-item>

                <div *ngIf="pageModel?.pagination?.totalResults < 1">
                  <h2>
                    <vs-product-not-found></vs-product-not-found>
                  </h2>
                </div>
              </ng-container>
            </ng-container>

            <!-- Product list when using infinite scroll -->
            <ng-template #infiniteScroll>
              <cx-product-scroll
                [scrollConfig]="scrollConfig"
                [model]="pageModel"
                [inputViewMode]="viewMode"
              ></cx-product-scroll>
            </ng-template>
          </div>
          <div class="cx-sorting bottom">
            <div class="row">
              <!-- <div class="col-6"></div> -->
              
              <div *ngIf="pageModel.pagination?.totalResults<itemsPerPage" class="col-3"></div>
              <div *ngIf="!isInfiniteScroll && pageModel.pagination?.totalResults > itemsPerPage" class="col-auto">
                <h4 class="sort_text">
                  {{ "plp.itemPerPageHdr" | cxTranslate }}
                </h4>
                <!-- <select class="select-box items-per-page" value="50" [(ngModel)]="itemsPerPage" (change)="getValue()">
                  <option *ngIf="(model.pagination.totalResults < pageModel.pagination.totalResults ? model.pagination.totalResults : pageModel.pagination.totalResults)" value="50" selected='true'>50</option>
                  <option *ngIf="(model.pagination.totalResults < pageModel.pagination.totalResults ? model.pagination.totalResults : pageModel.pagination.totalResults)>100" value="100">100</option>
                  <option *ngIf="(model.pagination.totalResults < pageModel.pagination.totalResults ? model.pagination.totalResults : pageModel.pagination.totalResults)>200" value="200">200</option>
                  <option *ngIf="(model.pagination.totalResults < pageModel.pagination.totalResults ? model.pagination.totalResults : pageModel.pagination.totalResults)>500" value="500">500</option>
                </select> -->
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "plp.selectPlaceholder" | cxTranslate }}'
                  class="items-per-page"
                  [(ngModel)]="itemsPerPage"
                  (change)="getValue($event)"
                >
                  <ng-option [value]="50" ng-selected="itemsPerPage == 50 ? true: false">50</ng-option>
                  <ng-option [value]="100" *ngIf="pageModel.pagination?.totalResults > 50" ng-selected="itemsPerPage == 100 ? true: false">100</ng-option>
                  <ng-option [value]="200" *ngIf="pageModel.pagination?.totalResults > 100" ng-selected="itemsPerPage == 200 ? true: false">200</ng-option>
                  <ng-option [value]="500" *ngIf="pageModel.pagination?.totalResults > 200" ng-selected="itemsPerPage == 500 ? true: false">500</ng-option>
                </ng-select>
              </div>

              <div
                *ngIf="!isInfiniteScroll && pageModel.pagination?.totalResults>itemsPerPage"
                class="col text-right btmpag"
                aria-label="product search pagination"
              >
                <div class="cx-pagination">
                  <cx-pagination
                    [pagination]="
                      pageModel.pagination
                    "
                    queryParam="currentPage"
                    [defaultPage]="currentPage"
                    (viewPageEvent)="currentPage($event)"
                  ></cx-pagination>
                </div>
              </div>

              <div class="col-md-3 mr-auto hidden">
                <h4 class="sort_text">{{ "plp.sortByHdr" | cxTranslate }}</h4>
                <div class="form-group cx-sort-dropdown mt20">
                  <cx-sorting
                    [sortOptions]="
                      pageModel.sorts
                    "
                    (sortListEvent)="sortList($event)"
                    [selectedOption]="
                      pageModel.pagination.sort
                    "
                    placeholder="{{
                      'productList.sortByRelevance' | cxTranslate
                    }}"
                  ></cx-sorting>
                </div>
              </div>

              <div class="col-1 ml-auto ml-lg-0 mt-22 hidden">
                <cx-product-view
                  (modeChange)="setViewMode($event)"
                  [mode]="viewMode"
                ></cx-product-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="((itemsPerPage != model.products.length) 
      && (pageModel.pagination?.totalPages > 1))" class="spinner-class">
      <div class="mb-0">
        <cx-spinner></cx-spinner>
      </div>
    </ng-container>
  </section>  
  
</div>
<ng-template #loading class="spinner-class">
  <div class="cx-spinner-container">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>

